import { useEffect } from "react";
import { questionModel } from "../../models";
import { getChildQuestions } from "../../services/api";
import { appConstants } from "../../utils/constants";
import { useDashboardContext } from "../customhook/dashboardHook";

export const ChildQuestionProvider = ({ children }) => {
  const { dashboardStates, setDashboardStates } = useDashboardContext();

  useEffect(() => {
    //Passing Selected Rating
    if (dashboardStates.parentQuestionId !== null) {
      let childQuestionResponse = () => {
        setDashboardStates((previousState) => {
          return {
            ...previousState,
            childQuestionloading: true,
          };
        });

        getChildQuestions({
          selectedQuestionId: dashboardStates.parentQuestionId,
          language: localStorage.getItem(appConstants.language),
        }).then((response) => {
          if (response?.status === 200 || response?.status === 201) {
            const responseData = response.data.data.map((questions) =>
              questionModel(questions.questionId, questions.questionName, false)
            );
            if (responseData != null && responseData.length > 0) {
              setDashboardStates((previousState) => {
                return {
                  ...previousState,
                  childQuestiondata: responseData,
                  childQuestionloading: false,
                };
              });
            }
          } else {
            setDashboardStates((previousState) => {
              return {
                ...previousState,
                childQuestiondata: null,
                childQuestionloading: false,
              };
            });
          }
        });
      };
      childQuestionResponse();
    }
  }, [dashboardStates.parentQuestionId, setDashboardStates]);

  return children;
};
